import { render } from "./OrgaoArtImg.vue?vue&type=template&id=0b1f6141&scoped=true"
import script from "./OrgaoArtImg.vue?vue&type=script&lang=ts"
export * from "./OrgaoArtImg.vue?vue&type=script&lang=ts"

import "./OrgaoArtImg.vue?vue&type=style&index=0&id=0b1f6141&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0b1f6141"

export default script